export default __webpack_public_path__ + "static/media/java-plain.a6881f38.svg";